// extracted by mini-css-extract-plugin
export default {"tooltip":"ui_tooltip__WM7Eh","scopes":"ui_scopes__ucirz","scopesChild":"ui_scopesChild__gb-C-","scopesCol":"ui_scopesCol__ETmlO"};